import { jsxs, jsx } from "react/jsx-runtime";
const IconBellSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M17 15V9a8.018 8.018 0 0 0-5.45-7.577 2.996 2.996 0 0 0-5.1 0A8.018 8.018 0 0 0 1 9v6a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2ZM3 15V9a6.008 6.008 0 0 1 4.411-5.78 1.001 1.001 0 0 0 .663-.591.996.996 0 0 1 1.852 0 1.002 1.002 0 0 0 .663.592A6.008 6.008 0 0 1 15 9v6H3Zm6 6a2.991 2.991 0 0 0 2.816-2H6.184A2.991 2.991 0 0 0 9 21Z" })
    ]
  }
);
export {
  IconBellSvg
};
